import React, { useEffect } from 'react';
import {useState, useContext} from 'react';
import ModalTest from '../BaseModal';
import { useNavigate } from 'react-router-dom';
import cross from '../../assets/orders/cross.svg'
import { InputLabel } from '../AddCompanyModal/style';
import { ButtonCreate } from '../routerModal/style';
import TableFiltersContext from '../../contexts/TableFiltersContext';
import UserContext from '../../contexts/UserContext';
import axios from '../../config/axios';
import { ButtonWrapper, CloseDiv, CloseImg, Container, ContentWrapper, FilterItem, HeaderDiv, HeaderText, InfoItem, InfoList, InfoSection, InfoTitle, LeftColumn, RightColumn, SwitchBox, SwitchDiv, SwitchInput, SwitchSlider } from './style';
import { useTenant } from '../../contexts/TenantContext';
import { tableFields, fashionStockDefault } from '../FieldManager/table-fields';
import { useUserPreferences } from '../../contexts/UserPreferencesContext';

 const ExportStockModal = () => {
    const { isFashionTenant } = useTenant();
    const localStorageKey = isFashionTenant ? 'tableFieldsFashion' : 'tableFields';
    const { getEffectivePreference } = useUserPreferences();

    const [selectedColumns, setSelectedColumns] = useState<boolean>(true);
    const [includeFilters, SetIncludeFilters] = useState<boolean>(true);
    const { stockFilters, globalFilter } = useContext(TableFiltersContext)
    const { user } = useContext(UserContext)
    const [selectedColumnsData, setSelectedColumnsData] = useState<any[]>([])
    const [filter, setFilter] = useState<any[]>(stockFilters)
    const navigate = useNavigate();

    const close = () => {
        navigate('..')
      }

    const sanitizeStockFields = (fieldsToSanitize: any, isFashionMode: boolean): any => {
      const forbiddenFields = [
        'quantity',
        'totalWeight',
        'lengthInMm',
        'costPerKg',
        'costPerMm',
        'totalCost',
        'measurementUnit',
        'nf',
        'certificateNumber'
      ]
      let cleanList = fieldsToSanitize.whichFieldsToShow.filter((f: any) => !forbiddenFields.includes(f.field))
      
      cleanList = cleanList.map((f: any) => {
        if (f.field === 'quantities') return { ...f, fieldName: 'Conjunto de Quantidades' }
        if (f.field === 'prices') return { ...f, fieldName: 'Conjunto de Preço' }
        return f
      })

      cleanList = cleanList.filter((f: any) => f.field !== 'isActivated')
      cleanList.unshift({ checked: true, field: 'isActivated', fieldName: 'Disponível' })

      if (!cleanList.some((f: any) => f.field === 'quantities')) {
        cleanList.push({ checked: true, field: 'quantities', fieldName: 'Conjunto de Quantidades' })
      }
      if (!cleanList.some((f: any) => f.field === 'prices')) {
        cleanList.push({ checked: true, field: 'prices', fieldName: 'Conjunto de Preço' })
      }
      if (!cleanList.some((f: any) => f.field === 'description')) {
        cleanList.push({ checked: true, field: 'description', fieldName: 'Descrição' })
      }
      if (!cleanList.some((f: any) => f.field === 'carrierCode')) {
        cleanList.push({ checked: false, field: 'carrierCode', fieldName: 'Código da transportadora' })
      }

      return {
        ...fieldsToSanitize,
        whichFieldsToShow: cleanList
      }
    }

      useEffect(()=>{
        const fromPrefs = getEffectivePreference<any[] | undefined>(localStorageKey);
        const defaultFromTable = isFashionTenant
          ? fashionStockDefault
          : (tableFields.find(field => field.tableSection === 'stock') || tableFields[0])

        const tableFieldsJson = fromPrefs ?? (isFashionTenant ? [fashionStockDefault] : tableFields);
        let foundFields = tableFieldsJson.find((field: any) => field.tableSection === 'stock');

        if (isFashionTenant && foundFields) {
          const hasColorField = foundFields.whichFieldsToShow.some((field: any) => field.field === 'color')
          if (!hasColorField) {
            foundFields = fashionStockDefault
          }
        }

        if (foundFields) {
          foundFields = sanitizeStockFields(foundFields, isFashionTenant)
        }
        const cleanDefaultFromTable = sanitizeStockFields(defaultFromTable, isFashionTenant)

        const resolvedFields = (foundFields && foundFields.whichFieldsToShow.some((field: any) => field.checked))
          ? foundFields
          : cleanDefaultFromTable;

        const whichFields = resolvedFields ? resolvedFields.whichFieldsToShow : [];
        setSelectedColumnsData(whichFields.filter((field: { checked: boolean, field: string, fieldName: string }) => field.checked));
      },[localStorageKey, getEffectivePreference, isFashionTenant])

      const exportSheets = async ()=>{
        try {
          const filters = includeFilters ? stockFilters:[]
          const fromPrefs = getEffectivePreference<any[] | undefined>(localStorageKey);
          const defaultFromTable = isFashionTenant
            ? fashionStockDefault
            : (tableFields.find(field => field.tableSection === 'stock') || tableFields[0])

          const tableFieldsJson = fromPrefs ?? (isFashionTenant ? [fashionStockDefault] : tableFields);
          let foundFields = tableFieldsJson.find((field: any) => field.tableSection === 'stock');

          if (isFashionTenant && foundFields) {
            const hasColorField = foundFields.whichFieldsToShow.some((field: any) => field.field === 'color')
            if (!hasColorField) {
              foundFields = fashionStockDefault
            }
          }

          if (foundFields) {
            foundFields = sanitizeStockFields(foundFields, isFashionTenant)
          }
          const cleanDefaultFromTable = sanitizeStockFields(defaultFromTable, isFashionTenant)

          const resolvedFields = (foundFields && foundFields.whichFieldsToShow.some((field: any) => field.checked))
            ? foundFields
            : cleanDefaultFromTable;

          const whichFields = resolvedFields ? resolvedFields.whichFieldsToShow : [];
          const columns = selectedColumns 
            ? whichFields.filter((field: { checked: boolean, field: string, fieldName: string }) => field.checked)
            : whichFields;
          const body = {
            filters,
            columns,
            global: includeFilters ? globalFilter : ''
          }

          const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/export-from-excel`,
              body,
              {
                  responseType:'blob',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  }
              }
          )

          if (response.data instanceof Blob) {
            const url = window.URL.createObjectURL(response.data)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'materiais-exportados.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          } else {
            console.error('Resposta não é um blob válido:', response.data)
          }
        } catch (error) {
          console.error('Erro na exportação:', error)
        }
      }
    return (
        <>
        <ModalTest>
            <Container>
                <HeaderDiv>
                    <HeaderText>{'Exportar Estoque'}</HeaderText>
                    <CloseDiv onClick={() => close()}>
                        <CloseImg src={cross} alt='Close tab' />
                    </CloseDiv>
                </HeaderDiv>

                <ContentWrapper>
                    <LeftColumn>
                        <SwitchDiv>
                            <InputLabel>Somente colunas selecionadas</InputLabel>
                            <SwitchBox>
                                <SwitchInput
                                    type="checkbox"
                                    onChange={() => setSelectedColumns(!selectedColumns)}
                                    checked={selectedColumns} />
                                <SwitchSlider className="slider"></SwitchSlider>
                            </SwitchBox>
                        </SwitchDiv>

                        <SwitchDiv>
                            <InputLabel>Exportar com filtros</InputLabel>
                            <SwitchBox>
                                <SwitchInput
                                    type="checkbox"
                                    onChange={() => SetIncludeFilters(!includeFilters)}
                                    checked={includeFilters} />
                                <SwitchSlider className="slider"></SwitchSlider>
                            </SwitchBox>
                        </SwitchDiv>

                        <ButtonWrapper>
                            <ButtonCreate style={{height: '2rem', width:'90%'}} onClick={async ()=> await exportSheets()}>
                                Baixar planilha
                            </ButtonCreate>
                        </ButtonWrapper>
                    </LeftColumn>

                    <RightColumn>
                        <InfoSection>
                            <InfoTitle>Colunas Selecionadas ({selectedColumnsData.length})</InfoTitle>
                            <InfoList>
                                {selectedColumnsData.length > 0 ? (
                                    selectedColumnsData.map((column, index) => (
                                        <InfoItem key={index}>
                                            {column.fieldName}
                                        </InfoItem>
                                    ))
                                ) : (
                                    <InfoItem style={{ opacity: 0.6 }}>
                                        Nenhuma coluna selecionada
                                    </InfoItem>
                                )}
                            </InfoList>
                        </InfoSection>

                        <InfoSection>
                            <InfoTitle>Filtros Aplicados ({filter.length})</InfoTitle>
                            <InfoList>
                                {filter.length > 0 ? (
                                    filter.map((filter, index) => (
                                        <FilterItem key={index}>
                                            <strong>{filter.field}</strong> {filter.type} {filter.text}
                                        </FilterItem>
                                    ))
                                ) : (
                                    <InfoItem style={{ opacity: 0.6 }}>
                                        Nenhum filtro aplicado
                                    </InfoItem>
                                )}
                            </InfoList>
                        </InfoSection>
                    </RightColumn>
                </ContentWrapper>
            </Container>
                
</ModalTest>
        </>
    )
}
export default ExportStockModal;
